import apiClient from '@/services/axios';

export async function get(dateString, venueId) {
  //dateString format: yyyy-MM-dd
  //venueId is optional
  var response = await apiClient.get(`/ActivationPlanEvents/${dateString}` + (venueId ? `/${venueId}` : ''));
  if (response) {
    return response.data
  }

  throw new Error('Unable to get calendar events by date');
}
